const Herbidata = [
    {
        _id:"1",
        name:`AK-71`,
        image:"/images/Herbicides/1.png",
        Title:`(Ammonium Salt of Glyphosate 71% SG)`,
        description: `It is a non-selective, post-emergence herbicide for the control of annual perennial, broadleaf and
        grassy weeds. Ammonium salt of Glyphosate 71% SG when applied to foilage reaches the roots and
        rhizpmes of the plant by the process of translocation, thus destroying the weeds from below the
        ground. It is especially effective against the difficult to control weeds. Apply to perennial weeds as
        post emergence application which should be have at least 4 to 8 leaves so that translocation into the
        plant can occur. Very early treatment of vegetation may reduce weed control but good results are
        obtained by treating mature plant.`
    },
    {
        _id:"2",
        name:`BINDASS`,
        image:"/images/Herbicides/2.png",
        Title:`(Paraquat Dichloride 24% SL)`,
        description: `It is a non selective, contact herbicide which containing 24% w/w active ingredient, Paraquat Dichloride a.i.
        by mass balance adjuvants. It is used to control Imperata cylindrica, Setaria sp., Commelina benghalenis,
        Boerhavia hispida paspa-lum conjugatum of tea and weeds of Potato, Cotton, Rubber, Rice, Wheat,
        Grapes & Aquatic Weeds. 1. Avoid inhalation and skin contact while diluting.Do not mix with bare hands.
        2. The users should use full protective clothings which include rubber gloves, boots and either face shield
        or mdust mask and overall rubber apron, hood or hat.`
    },
    {
        _id:"3",
        name:`BUTA MILK`,
        image:"/images/Herbicides/3.png",
        Title:`(Butachlor 50% EW)`,
        description: `It is pre- emergence selective herbicide with controls important annual grasses, sedges and broad leaf
        weeds in transplanted rice. Approved for controlling annual grasses, sedges and broad leaf weeds in
        transplanted Rice. Apply as a blanket spray within four days after transplantation.
        
        Time of Application:
        
        1. Apply a blanket spray, apply within 4 days after transplantation.
        2. Soil Surface should be moist while sparying and it is desirable not to have water. If the top soil is dry, Butachlor is not fully effective.
        3. Avoid reflooding the field up to 24 hours after application.`
    },
    {
        _id:"4",
        name:`CLEAR CUT 38`,
        image:"/images/Herbicides/4.png",
        Title:`(2,4-D Ethyl Ester 38% E.C)`,
        description: `It is a herbicide which contain 38% active ingredient 2,4-D Ethyle Ester by mass and balance adjuvants. It
        is recommended to control Cyperus iria, Striga spp., Trianthema spp., Tridax procumbens, Digera arvensis
        of sorghum, Trianthema monogyna, Amaranthus spp., etc of maize, Chenopodium album, Asphodelus
        teunuifolius, Fumaria parviflora, Melilotus alba, Spergula arvensis of Wheat, Eichhorinia crassipes of
        aquatic weeds and Echinochloa colonum, Echinochloa crusgalli of rice crop.`
    },
    {
        _id:"5",
        name:`CLEAR CUT 58`,
        image:"/images/Herbicides/5.png",
        Title:`(2,4-D amine salt 58% S.L)`,
        description: `It is recommended to control Cyperus iria, Striga spp, Trianthema spp., Tridax procumbens, Digera
        arvensis of sorghum, Trianthema monogyna, Amaranthus spp., etc of maize, Chenopodium album,
        Asphodelus tenuefolius, Fumaria spp, Melilotus alba of wheat. Eichhornia crassipes as aquatic weeds and
        other weeds of Potato, sugarcane and non crop area.`
    },
    {
        _id:"6",
        name:`G-GRIP`,
        image:"/images/Herbicides/6.png",
        Title:`(Metsulfuron Methyl 20% WP)`,
        description: `It is a post emergence herbicide belonging to chemical family of sulfonyl urea herbicides. Metsuslforun
        Methyl predominately controls broad leaf weeds of Wheat, Transplated rice and Sugar Cane crops.
        Method of application:- As spary suspension in 500-600 lit water per hectare.
        Recommandation for Surfactant Use: Add non ionic surfactant (ISO-Octyl-phenoxyl poloxethanol 12.5%) @
        2 ml/litre of spray volume (0.2%) when used in the sugarcane and wheat crop. Surfactant not to be added
        when used in the Transplanted Rice Crop. Herbicides not to be used in intercropping/mixed cropping.
        Drift Management: Extreme care should be taken to avoid damage by drift onto broad leaf plants outside
        the target area or on to water sources.
        Time of Application
        Wheat: 25-35 days after sowing (1 Spray).`
    },
    {
        _id:"7",
        name:`G-STAR`,
        image:"/images/Herbicides/7.png",
        Title:`(Atrazine 50% W.P.)`,
        description: `It is a herbicide which contains 50% W.P w/w atrazine active ingredient and valance adjuvants. It
        is recommended to control Trianthema monogyna, Digitaria arvensis, Echinocloa, spp. Elusine
        spp., Xanthium strumarium, Brachiaria sp., Digitaria sp., Amaranthus viridies, Cleome viscosa,
        Polygonum sp. of maize. Partulaca oleracea, Digiteria sp. Boerhavia diffusa, Euphorbia sp.,
        Tribulus terrestris of sugarcane crop.
        Time of Application:
        Maize :Immediately after transplanting (pre-emergence).
        Sugarcane: Pre-emergence on weed free soil.`
    },
    {
        _id:"8",
        name:`GCM-29`,
        image:"/images/Herbicides/8.png",
        Title:`(Clodinafop Propagyl 9% + Metribuzin 20% WP)`,
        description: `It is selective and post emergence herbicide used for weeds control in wheat crop, which contains
        Clodinafop Propagyl (9% a.i.) Metribuzin (20% a.i.) and remaining adjuvant. It is recommended for the
        control of phalaris minor, plebeium, medicago spp. melilotus spp., chenopodium album, cronopus didymus,
        vicia sativa, rumex spp, dinebra retroflexa on wheat crop.
        Time of Application: This herbicide is recommended for post emergence application i.e. 35 days after
        sowing of wheat crop when weeds are 3-4 leaves stage.`
    },
    {
        _id:"9",
        name:`OXY-GEN`,
        image:"/images/Herbicides/9.png",
        Title:`(Oxyflourfen 23.5% E.C)`,
        description: `It is a selective herbicide containing oxyflurofen active ingredient 23.5% E.C. It has a residual activity and controls important weeds in crops like for control major grasses, broadleaf and
        sedges in direct seeded rice, tea, potato, onion, groundnut and mentha crops.`
    },
    {
        _id:"10",
        name:`PANDA EXTRA`,
        image:"/images/Herbicides/10.png",
        Title:`(Pendimethalin 38.7 % CS)`,
        description: `It is selective herbicide for use in soybean, Cotton, Chilli and Onion crop which controls
        susceptible annual grasses and broad leaf weeds as they germinate. pendimethalin 38.7% CS
        does not control perennial or well established weeds. Pendimethalin 38.7% CS can be applied as pre-plant incorporation in Soybean and preemergence
        application in Cotton, transplanted Chilli and Onion . Incorporate Pendimethalin
        38.7% CS in top 2-5 cm of soil with a suitable farm implement for application as Pre-plant
        incorporation. For weed control in cotton before sowing or within 3 days after sowing. In Chilli and
        Onion apply just before transplanting or within 3 days of transplanting as pre-emergence
        application. Before application, ensure that the field is prepared fine, firm and free of clods.
        Spray Pendimethalin 38.7% CS using high volume sprayer like knapsack sprayer/foot sprayer
        fitted with flat fan nozzle.`
    },
    {
        _id:"11",
        name:`PANDA PLUS`,
        image:"/images/Herbicides/11.png",
        Title:`(Pendimethalin 30 % EC)`,
        description: `It is a emulsifiable pre-emergence selective herbicide containing Pendimethalin 30% w/w and
        balance other relevant ingredients. It is recommended to control weeds in Wheat, Rice
        (transplanted & Direct Sown upland), Cotton & Soybean crops.`
    },
    {
        _id:"12",
        name:`PRETILA 50`,
        image:"/images/Herbicides/12.png",
        Title:`(Pretilachlor 50% EC)`,
        description: `It is a herbicide recommended for its use to control grasses, sedges & broad leaved weeds like
        echinochloa spp., cyperus iria, cyperus difformis, fimbristylis miliaceae, eclipta alba, ludwigia
        parvifrlora, monochoria vaginalis, laptochloa chinensis and pannicum repens in transplanted rice.
        Measure out required of the product and mix it well with a small quantity of water as specified with
        thorough agitation for high volume application throught knapsack sprayer with flat fan/ flood zet
        nozzle.`
    },
    {
        _id:"13",
        name:`RAFALE`,
        image:"/images/Herbicides/13.png",
        Title:`(Clodinafop – Propargyl 15% WP)`,
        description: `This herbicide is taken up through leaves of grass weeds. Active growth of susceptible grasses
        ceases within 48 hours after application. Symptoms are observed within one to three weeks
        depending on environmental condition and species involved. Decay of nodes and growing points
        is visible with young leaves showing chlorosis followed by necrosis. Re-cropping flexibility:
        This is a post emergence herbicide used to control phalaris minor weed on wheat.
        This herbicide quickly degrade in the soil and has little or no soil activity. There are no recropping
        restrictions.`
    },
    {
        _id:"14",
        name:`SAFA CHATT`,
        image:"/images/Herbicides/12.png",
        Title:`(Glyphosate 41% SL)`,
        description: `It is non – selective a herbicide which contains Isopropylamine salt of glyphosate 41% (w/w) and
        balance inert material and auxilliaries. It is effective against annual and perennial grasses and
        broadleaf weeds of tea and non cropped area. Plant Protection Equipment : Knapsack sprayer
        fitted with a flat fan or flood jet nozzle is to be used while applying the weedicide Gator rocking
        sprayer & Knapsack weedicide sprayer can also be used. Prepararation of Spray Solution : Add
        slowly the required quantity of weedicides to water & stir well, with a stick or rod. While preparing
        large quantity of spray solution & weedicide to a bucket of half filled with water. Stir & then empty
        the pre-solution into the bulk of water.`
    },
    {
        _id:"15",
        name:`SAFA CHATT PLUS`,
        image:"/images/Herbicides/15.png",
        Title:`(Glyphosate 41% SL)`,
        description: `It is non – selective a herbicide which contains Isopropylamine salt of glyphosate 41% (w/w) and
        balance inert material and auxilliaries. It is effective against annual and perennial grasses and
        broadleaf weeds of tea and non cropped area. Plant Protection Equipment : Knapsack sprayer
        fitted with a flat fan or flood jet nozzle is to be used while applying the weedicide Gator rocking
        sprayer & Knapsack weedicide sprayer can also be used. Prepararation of Spray Solution : Add
        slowly the required quantity of weedicides to water & stir well, with a stick or rod. While preparing
        large quantity of spray solution & weedicide to a bucket of half filled with water. Stir & then empty
        the pre-solution into the bulk of water.`
    },
    {
        _id:"16",
        name:`SAFA CHATT SUPER`,
        image:"/images/Herbicides/16.png",
        Title:`(IPA Salt of Glyphosate 54% SL)`,
        description: `It is a weedicide which contains 54% active ingredient glyphosate in the form of Isopropyl-amine
        salt and balance inert ingredient by mass. It is recommended to control weeds ageratum
        conyzoides, alternenthera sessile, echinochloa spp., eclipta alba, ischaemum rugosum, setaria
        spp., commelina spp., cyperus spp. (for general weed control in non cropped areas.)`
    },
]
export default Herbidata;